import { gql } from '@apollo/client';
import { LocationEmailFragment } from 'graphql/LocationEmail/fragments/LocationEmailFragment';
import { LocationPhoneFragment } from 'graphql/LocationPhone/fragments/LocationPhoneFragment';
/**
 * @fragment LocationFragment
 * @since 1.0.0
 */
export const LocationFragment = gql `
  fragment LocationFragment on Location {
    id
    name
    address
    civicNumber
    road
    apartment
    city
    province
    postalcode
    country
    primary
    billing
    shipping
    latitude
    longitude
    updatedAt
    createdAt

    emails {
      ...LocationEmailFragment
    }

    primaryEmail {
      ...LocationEmailFragment
    }

    phones {
      ...LocationPhoneFragment
    }

    primaryPhone {
      ...LocationPhoneFragment
    }
  }

  ${LocationEmailFragment}
  ${LocationPhoneFragment}
`;
